import { Modal } from 'bootstrap';

function initializeDeactivateModal() {
  const modalEl = document.getElementById('deactivateModal');
  if (!modalEl) return;

  const deactivateButtons = document.querySelectorAll('.deactivate-btn');
  const confirmButton = document.getElementById('confirmDeactivate');
  const dateInput = document.getElementById('deactivate_date');
  let currentCardRateId = null;

  const existingModal = Modal.getInstance(modalEl);
  if (existingModal) {
    existingModal.dispose();
  }

  const bootstrapModal = new Modal(modalEl, { backdrop: 'static', keyboard: false });

  deactivateButtons.forEach((button) => {
    button.removeEventListener('click', handleDeactivateClick);
    button.addEventListener('click', handleDeactivateClick);
  });

  function handleDeactivateClick(e) {
    e.preventDefault();
    currentCardRateId = e.target.dataset.cardRateId;

    const now = new Date();
    const localDateTime = new Date(now.getTime() - now.getTimezoneOffset() * 60000)
      .toISOString()
      .slice(0, 16);
    dateInput.min = localDateTime;
    dateInput.value = localDateTime;

    bootstrapModal.show();
  }

  confirmButton.removeEventListener('click', handleConfirmClick);
  confirmButton.addEventListener('click', handleConfirmClick);

  function handleConfirmClick() {
    if (currentCardRateId && dateInput.value) {
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = `/card_cashback_rates/${currentCardRateId}/deactivate`;

      const csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
      const csrfInput = document.createElement('input');
      csrfInput.type = 'hidden';
      csrfInput.name = 'authenticity_token';
      csrfInput.value = csrfToken;

      const dateInputField = document.createElement('input');
      dateInputField.type = 'hidden';
      dateInputField.name = 'end_date';
      dateInputField.value = dateInput.value;

      form.appendChild(csrfInput);
      form.appendChild(dateInputField);
      document.body.appendChild(form);
      form.submit();
    }
  }
}

document.addEventListener('turbo:load', initializeDeactivateModal);
